import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Card } from "../components/Layout";
import bookingApi from "../service/bookingApi";
import { TiTickOutline } from "react-icons/ti";

const Success = () => {
  const params = useParams();
  const id = params.id;
  const navigate = useNavigate();
  const [error, setError] = useState(null); // 'SLOT_TAKEN' | 'GENERIC' | null

  useEffect(() => {
    const confirmBooking = async () => {
      if (id) {
        try {
          const response = await bookingApi.createBooking(id);
          if (response?.customerId) {
            setTimeout(() => {
              navigate("/questionnaire", {
                state: { customerId: response.customerId },
              });
            }, 1000);
          } else {
            console.error("Customer ID is missing in the response");
            setError("GENERIC");
          }
        } catch (err) {
          console.error("Error confirming booking:", err);
          setError(err?.data?.errorCode === "SLOT_TAKEN" ? "SLOT_TAKEN" : "GENERIC");
        }
      }
    };

    confirmBooking();
  }, [id]);

  if (error) {
    return (
      <Container>
        <Card style={{ textAlign: "center", padding: "25px" }}>
          <h1>Booking kunne ikke gennemføres</h1>
          <div
            style={{
              color: "#B23A48",
              fontWeight: "bold",
              fontSize: "18px",
              marginTop: "20px",
              padding: "15px",
              borderRadius: "10px",
              backgroundColor: "#FFE8E8",
              display: "inline-block",
              maxWidth: "90%",
              lineHeight: "1.5",
            }}
          >
            {error === "SLOT_TAKEN"
              ? "Den valgte tid blev desværre optaget, inden din booking blev gennemført. Vælg venligst et andet tidspunkt."
              : "Der opstod en fejl under bekræftelsen af din booking. Prøv venligst igen."}
          </div>
          <div style={{ marginTop: "20px" }}>
            <button
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#018D66",
                color: "white",
                cursor: "pointer",
                fontSize: "16px",
              }}
              onClick={() => navigate("/")}
            >
              Vælg et andet tidspunkt
            </button>
          </div>
        </Card>
      </Container>
    );
  }

  return (
    <Container>
      <Card style={{ textAlign: "center", padding: "25px" }}>
        <h1>🎉 Betaling gennemført!</h1>
        <div style={{ fontSize: "70px", color: "#018D66", fontWeight: "bold" }}>
          <TiTickOutline />
        </div>
        <div
          style={{
            color: "#B23A48",
            fontWeight: "bold",
            fontSize: "18px",
            marginTop: "20px",
            padding: "15px",
            borderRadius: "10px",
            backgroundColor: "#FFE8E8",
            display: "inline-block",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            maxWidth: "90%",
            lineHeight: "1.5",
          }}
        >
          📝 Udfyld venligst følgende spørgsmål for at sikre et problemfrit
          møde.
        </div>
      </Card>
    </Container>
  );
};

export default Success;
